
export default class NguonNuocBaoVe {
    constructor() {

    }
}